import { createBrowserRouter } from "react-router-dom";

import Login from "./pages/Login";
import AdminList from "./pages/AdminList";
import Marketting from "./pages/Marketting";
import AddVideo from "./pages/AddVideo";
import ProcessedOutput from "./pages/ProcessedOutput";
import Videos from "./pages/videos";
import PlannerList from "./pages/PlannerList";
import Test from "./pages/Test";
import ControllerList from "./pages/ControllerList";
import CreateBrief from "./pages/CreateBrief";
import BriefList from "./pages/BriefList";
import EditBrief from "./pages/EditBrief";
import PlannerBriefList from "./pages/Planner/BriefList";
import PlannerBriefDetails from "./pages/Planner/BriefDetails";
import PlannerStartPlanning from "./pages/Planner/StartPlanning";
import PlannerVideoDetails from "./pages/Planner/VideoDetails";
import AssetInfo from "./pages/AssetInfo";
import KeyMetricsPage from "./pages/KeyMetricsPage";
import EditVideoMarkets from "./pages/EditVideoMarkets";
import DateSelection from "./pages/DateSelection";
import ForecastVisibilityGraph from "./pages/Planner/StartPlanning/ForecastVisibilityGraph";
import CampaignReport from "./pages/CampaignReport";
import CampaignGraphs from "./pages/CampaignReport/CampaignGraphs";
import GeospatialData from "./pages/GeospatialData";
import AddVideoLatLong from "./pages/AddVideoLatLong";
import BulkReview from "./pages/AddVideo/BulkReview";
import ImpressionGraphs from "./pages/Planner/StartPlanning/ImpressionGraphs";
import Agent from "./pages/Agent";
import UploadTemp from "./pages/UploadTemp";
export const authRouter = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <Test />,
  },
  
]);

export const superAdminRouter = createBrowserRouter([
  {
    path: "/marketing",
    element: <Marketting />,
  },
  {
    path: "/",
    element: <BriefList />,
  },
  {
    path: "/controllers",
    element: <ControllerList />,
  },
  {
    path: "/datetime",
    element: <DateSelection />,
  },
  {
    path: "/campaignreport",
    element: <CampaignReport />,
  },
  {
    path: "/admins",
    element: <AdminList />,
  },
  {
    path: "/planners",
    element: <PlannerList />,
  },
  {
    path: "/add-video",
    element: <AddVideo />,
  },
  // Hidden temporary upload endpoint (not linked in navigation)
  {
    path: "/upload-temp",
    element: <UploadTemp />,
  },
  {
    path: "/add-video/:video_id/processed-output",
    element: <ProcessedOutput />,
  },
  {
    path: "/add-asset/:assetId",
    element: <AssetInfo />,
  },
  {
    path: "/bulk-review/:roomId",
    element: <BulkReview />,
  },
  {
    path: "/videos",
    element: <Videos />,
  },
  {
    path: "/create-brief",
    element: <CreateBrief />,
  },
  {
    path: "/briefs",
    element: <BriefList />,
  },
  {
    path: "/edit-brief/:brief_id",
    element: <EditBrief />,
  },
  {
    path: "/key-metrics",
    element: <KeyMetricsPage />,
  },
  {
    path: "/campaignreport/:campaignId/graphs",
    element: <CampaignGraphs />,
  },
  {
    path: "/geospatial-data",
    element: <GeospatialData />,
  },
  {
    path: "/geospatial-data/edit-video-markets",
    element: <EditVideoMarkets />,
  },
  {
    path: "/geospatial-data/add-video-lat-long",
    element: <AddVideoLatLong />,
  },
  {
    path : "/agent",
    element : <Agent />
  },
  {
    path: "*",
    element: <Test />,
  },
]);

export const adminRouter = createBrowserRouter([
  {
    path: "/add-video",
    element: <AddVideo />,
  },
  {
    path: "/upload-temp",
    element: <UploadTemp />,
  },
  {
    path: "/add-video/:video_id/processed-output",
    element: <ProcessedOutput />,
  },
  {
    path: "/add-asset/:assetId",
    element: <AssetInfo />,
  },
  {
    path: "/planners",
    element: <PlannerList />,
  },
  {
    path: "/",
    element: <Videos />,
  },
  {
    path: "/videos",
    element: <Videos />,
  },
  {
    path: "*",
    element: <Test />,
  },
]);

export const controllerRouter = createBrowserRouter([
  {
    path: "/",
    element: <BriefList />,
  },
  {
    path: "/create-brief",
    element: <CreateBrief />,
  },
  {
    path: "/edit-brief/:brief_id",
    element: <EditBrief />,
  },
  {
    path: "*",
    element: <Test />,
  },
]);

export const plannerRouter = createBrowserRouter([
  {
    path: "/",
    element: <PlannerBriefList />,
  },
  {
    path: "/briefs/:brief_id",
    element: <PlannerBriefDetails />,
  },
  {
    path: "/videos/:video_id/all-data",
    element: <PlannerVideoDetails />,
  },
  {
    path: "/briefs/:budget_id/start-planning",
    element: <PlannerStartPlanning />,
  },
  {
    path: "/forecast-visibility-map/:id",
    element: <ForecastVisibilityGraph />,
  },
  {
    path: "/calculate-impression-map/:id",
    element: <ImpressionGraphs />,
  },
  {
    path: "*",
    element: <Test />,
  },
]);
